export default __webpack_public_path__ + "static/media/blog-fire-pit-001.d004a692.jpg";